export const FETCH_BATCH_LABEL_FILE_SUCCESS = 'FETCH_BATCH_LABEL_FILE_SUCCESS';
export const FETCH_BATCH_LABEL_FILE_REQUEST = 'FETCH_BATCH_LABEL_FILE_REQUEST';
export const FETCH_BATCH_LABEL_FILE_FAILURE = 'FETCH_BATCH_LABEL_FILE_FAILURE';
export const FETCH_BATCH_LABEL_FILE_REST = 'FETCH_BATCH_LABEL_FILE_REST';
export const fetchBatchLabelSuccess = (payload) => ({
    type: FETCH_BATCH_LABEL_FILE_SUCCESS,
    payload,
});
export const fetchBatchLabelRequest = (payload) => ({
    type: FETCH_BATCH_LABEL_FILE_REQUEST,
    payload,
});
export const fetchBatchLabelFailure = (payload) => ({
    type: FETCH_BATCH_LABEL_FILE_FAILURE,
    payload,
});
export const fetchBatchLabelReset = () => ({
    type: FETCH_BATCH_LABEL_FILE_REST,
});
